import request from '../utils/request';

export const fetchStockAlerts = (params) => request.get('/admin/stock-alerts', { params });
export const fetchStockAlertStats = () => request.get('/admin/stock-alerts/stats');
export const checkStockAlerts = () => request.post('/admin/stock-alerts/check');
export const resolveStockAlert = (id, data) => request.put(`/admin/stock-alerts/${id}/resolve`, data);
export const ignoreStockAlert = (id, data) => request.put(`/admin/stock-alerts/${id}/ignore`, data);
export const setStockAlertThresholds = (data) => request.post('/admin/stock-alerts/thresholds', data);
export const fetchStockAlertThresholds = () => request.get('/admin/stock-alerts/thresholds');
export const cleanupStockAlerts = (data) => request.post('/admin/stock-alerts/cleanup', data);
